<template>
  <div class="roles-container">
    <div class="roles-header">
      <div class="header-left">
        <!-- <SearchButton v-model="usersSearchText" /> -->
      </div>
      <div class="header-right">
        <button class="add-button" @click="openRolesModal()">
          <span class="material-symbols-outlined align-middle"> add </span> Add Role
        </button>
      </div>
    </div>
    <div v-if="roles?.length > 0" class="roles-list">
      <table>
        <thead>
          <tr>
            <th class="name" style="min-width: 250px">Role Name</th>
            <th class="users-count" style="width: 80px">Users</th>
            <th class="created" style="width: 120px">Created</th>
            <th style="width: 56px"></th>
          </tr>
        </thead>
        <tbody class="scrollbar">
          <tr class="role" v-for="role in roles" v-bind:key="role.role_id" :id="role.role_id">
            <td class="name">
              {{ role.name }}
            </td>
            <td class="users-count-td">
              {{ role.users }}
            </td>
            <td class="created">
              {{ formattedDate(role.created, 'DD/MM/YYYY') }}
            </td>

            <td class="dropdown">
              <i
                class="material-icons align-middle more-buttons dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                more_vert
              </i>

              <div class="role-options dropdown-menu dropdown-menu-right">
                <button type="button" class="dropdown-item" @click="openRolesModal(role)">
                  <i class="material-icons align-middle">edit</i>
                  Edit Role
                </button>

                <button type="button" class="dropdown-item" @click="openRemoveRoleModal(role)">
                  <i class="material-icons align-middle">delete</i>
                  Remove
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="no-data">No roles added</div>

    <RolesModal
      @closeModal="closeRolesModal"
      :role="selectedRole"
      v-if="showRoleModal"
      title="Edit Role"
    />

    <RemoveRoleModal
      @closeModal="showRemoveRoleModal = false"
      :role="selectedRole"
      v-if="showRemoveRoleModal"
    />
  </div>
</template>

<script>
  import moment from 'moment';
  import RolesModal from '@/components/admin/OrganisationDetails/Roles/RolesModal.vue';
  import RemoveRoleModal from '@/components/admin/OrganisationDetails/Roles/RemoveRoleModal.vue';
  import SearchButton from '@/components/common/SearchButton.vue';
  import { GET_ORGANISATION_ROLES } from '@/store/actions/roles';

  export default {
    name: 'RolesList',

    components: { RolesModal, RemoveRoleModal, SearchButton },

    data() {
      return {
        selectedRole: null,
        showRoleModal: false,
        showRemoveRoleModal: false,
        usersSearchText: '',
      };
    },

    computed: {
      roles() {
        return this.$store.state.roles.roles.map((role) => ({
          users: role.total_users,
          ...role,
        }));
      },
      isAdmin() {
        return this.$store.getters.isAdministrator;
      },
    },

    async created() {
      await this.$store.dispatch(GET_ORGANISATION_ROLES);
    },

    methods: {
      formattedDate(date, format) {
        return moment(date).format(format);
      },
      openRemoveRoleModal(role) {
        this.selectedRole = role;
        this.showRemoveRoleModal = true;
      },

      openRolesModal(role = null) {
        this.selectedRole = role;
        this.showRoleModal = true;
      },

      closeRolesModal() {
        this.selectedRole = null;
        this.showRoleModal = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .roles-container {
    height: 100%;

    .roles-list {
      height: calc(100% - 50px);
      overflow-y: auto;
    }
    .role {
      &:hover {
        cursor: pointer;
      }

      .name {
        flex-grow: 1;
      }

      .right {
        display: flex;
        gap: 16px;
      }

      .users {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-grow: 1;
      }
    }
  }

  table {
    background-color: $backgroundGrey;
    width: 100%;
    font-size: 14px;
    border: none;
    border-spacing: 0 8px;
    border-collapse: separate;
    table-layout: fixed;
  }

  thead {
    background-color: $backgroundGrey;
    height: 50px;
    position: sticky;
    top: 0;
    z-index: 2;
    width: 100%;
  }

  th {
    padding: 15px;
  }

  tbody {
    width: 100%;

    tr {
      width: 100%;
      background-color: #fff;
      cursor: pointer;
      font-size: 14px;
      // background-color: aqua;

      td {
        // height: 56px;
        padding: 15px;
        border-top: 2px solid transparent;
        border-bottom: 2px solid transparent;

        &:first-child {
          border-left: 2px solid transparent;
        }

        &:last-child {
          border-right: 2px solid transparent;
        }
      }
      &:hover,
      &.selected,
      &.renew-selected {
        td {
          border-top: 2px solid $primaryRed;
          border-bottom: 2px solid $primaryRed;

          &:first-child {
            border-left: 2px solid $primaryRed;
          }

          &:last-child {
            border-right: 2px solid $primaryRed;
          }
        }
      }

      .users-count-td {
        padding: 0px 20px;
      }
    }
  }

  .roles-header {
    display: grid;
    grid-template-columns: auto 120px;
    align-items: center;
    height: 40px;
    padding: 0;
    margin: 10px 10px;
  }

  .add-button {
    width: 100%;
    color: #e3003a;
    font-family: Poppins;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
    text-align: center;
    cursor: pointer;
    font-weight: bold !important;
    display: flex;
    justify-content: space-evenly;
    border: none;
    background-color: transparent;
    gap: 12px;
  }
</style>
